<style type="text/css">
	#campaign-category::scrollbar {
		width: thin !important;
	}
	#content-data::scrollbar {
    	width: thin;
	}
	#content-data::scrollbar-track {
	    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	}
	#content-data::scrollbar-thumb {
	  background-color: darkgrey;
	  outline: 1px solid slategrey;
	}

	#content-data {
		scrollbar-width: thin;
		scrollbar-color: red;
	}
</style>
<template>
	<section class="vx-row mb-12">
		<!-- Donation -->
		<div class="vx-col w-full lg:w-1/3 mb-6 md:mb-0">
			<header class="flex justify-between mb-8 ">
				<p><strong>Donasi</strong></p>
				<p><small>
					<router-link to="/zxcare" class="text-primary">
						Lihat Semua
					</router-link>
				</small></p>
			</header>
			<div id="content-data" style="overflow-x: auto !important;scroll-snap-type: x mandatory;max-width: 100%;min-width: 100px;" >
				<div class="flex w-full justify-center lg:justify-center">
					<router-link 
						v-for="(item, i) in category"
						:key="i"
						:to="getZisLink(item)" class="flex flex-col justify-center mx-2"
					>

						<div class="mx-auto">
							<img v-if="item.file_url === null" v-lazy="`/assets/images/donation/zakat.svg`" alt="" class="w-16" />
							<img v-else v-lazy="item.file_url" alt="" class="w-16" />
						</div>
						<small class="block w-20 text-center text-center"><strong>{{item.name}}</strong></small>
					</router-link>
				</div>
			</div>
		</div>
		<!-- / -->

		<!-- Donation Categories -->
		<div class="vx-col w-full lg:w-2/3 border-kiri">
			<header class="flex justify-between mb-8 ">
				<p><strong>Kategori Donasi</strong></p>
				<p><small>
					<router-link to="/zxcare" class="text-primary">
						Lihat Semua
					</router-link>
				</small></p>
			</header>
			<div class="relative w-full px-0 md:px-6" id="campaign-category" style="overflow-x: auto !important;scroll-snap-type: x mandatory;max-width: 100%;min-width: 100px;">
				<div class="flex">
					<router-link 
						v-for="(item, i) in categoryDonation"
						:key="i"
						:to="`/zxcare?k=${item.id}`" 
						class="flex flex-col justify-center mx-2 w-full"
						style="scroll-snap-align: start;"
					>
						<div class="flex justify-center w-full mb-4">
							<img v-if="item.file_url" v-lazy="item.file_url" alt="" class="w-12" />
							<img v-else v-lazy="`/assets/images/donation/kesehatan.svg`" class="w-12" alt="" />
						</div>
						<small class="block w-20 text-sm text-center"><strong>{{ truncateString(item.name, 10)}}</strong></small>		
					</router-link>
				</div>
			</div>
		</div>
		<!-- / -->
	</section>
</template>
<script>
export default {
  data: () => ({
	category: [],
    categoryDonation: []
  }),
  beforeMount() {
	  this.$vs.loading()

	  this.$store.dispatch('getZisCategory')
	  .then(kategori => {
		  this.$vs.loading.close();
		  kategori.map(item => {
			  item.file_url = null
			  if(item.file !== null) {
				  item.file_url = process.env.VUE_APP_STORAGE + '/' + item.file
			  }

		  });
		  this.category = kategori;
	  })
	  .catch(e => this.$vs.loading.close())
  },
  created() {
	  this.$store.watch(
		  (state) => {
			  return this.$store.getters['campaign/getCategoryCampaign']
		  },
		  (val) => {
			  if(val) {
				  val.map(item => {
					  item.file_url = null
					  if(item.file !== null && item.file != '') {
						  item.file_url = process.env.VUE_APP_STORAGE + '/' + item.file
					  }	
				  })

				  this.categoryDonation = val;
			  }
		  },
		  {
			  deep: true
		  }
	  )
  }
}
</script>	